import { FaberApi } from 'api'
import { AxiosPromise } from 'axios'
import { EsimAuditLogType } from 'types/api/faber/customerAuditLog.type'

class EsimAPI {
  /**
   * to resend a esim subscription email
   * @param iccid
   * @returns Promise<AxiosResponse<any, any>>
   */
  static resendEsimSubscriptionEmail(body: {
    iccid: string
    faberToken: string
  }) {
    return FaberApi.httpGet(
      `/esim/resend/${body.iccid}`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      true
    )
  }

  static getEsimAuditLogs(
    userId: string,
    faberToken: string
  ): AxiosPromise<EsimAuditLogType> {
    return FaberApi.httpGet(
      `/audit/esim/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static getExternalEsimAuditLogs(
    userId: string,
    faberToken: string
  ): AxiosPromise<EsimAuditLogType> {
    return FaberApi.httpGet(
      `/sim/ext/audit/esim/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static createDeleteRequest({
    userId,
    faberToken,
    status = 'PENDING_DELETION'
  }: {
    userId: string
    faberToken: string
    status?: 'PENDING_DELETION' | 'CANCELLED' | 'COMPLETED'
  }) {
    return FaberApi.httpPost(
      `/sim/ops/account/deletion`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        userId,
        status
      }
    )
  }

  static getDeleteRequest({
    userId,
    faberToken
  }: {
    userId: string
    faberToken: string
  }) {
    return FaberApi.httpGet(
      `/sim/ops/account/deletion/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }

  static resendEsimEmail({
    userId,
    faberToken,
    oldICCID
  }: {
    userId: string
    faberToken: string
    oldICCID?: string
  }) {
    return FaberApi.httpPost(
      `/sim/ops/notification/esim/resend/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        oldICCID
      }
    )
  }

  static undoDeleteRequest({
    userId,
    faberToken,
    status
  }: {
    userId: string
    faberToken: string
    status: 'CANCELLED' | 'PENDING_DELETION' | 'COMPLETED'
  }) {
    return FaberApi.httpPost(
      `/sim/ops/account/deletion`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        userId,
        status
      }
    )
  }

  static externalResendEsimEmail({
    userId,
    faberToken,
    oldICCID
  }: {
    userId: string
    faberToken: string
    oldICCID?: string
  }) {
    return FaberApi.httpPost(
      `/sim/ext/notification/esim/resend/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      { oldICCID }
    )
  }
  static getCustomerPacks({
    userId,
    faberToken,
    limit,
    offset
  }: {
    userId: string
    faberToken: string
    limit: number
    offset: number
  }) {
    return FaberApi.httpGet(
      `/sim/ops/allocation/user/${userId}?limit=${limit}&offset=${offset}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      true
    )
  }
  static ReassignPackage({
    userId,
    email,
    packageId,
    firstName,
    lastName,
    faberToken
  }) {
    return FaberApi.httpPut(
      `/sim/ops/plan/package/reassign/${userId}`,
      {
        Authorization: `Bearer ${faberToken}`
      },
      {
        email,
        packageId,
        firstName,
        lastName
      }
    )
  }

  static esimAllocateByWhitelistID(body: { user_id: string; user_email: string; user_name: string; Whitelist_id: string; faberToken: string }) {
    return FaberApi.httpPost(
      `/sim/ops/esim/assign-by-whitelist`,
      {
        Authorization: `Bearer ${body.faberToken}`
      },
      body
    )
  }

  static getCustomerVoicePlans(body: { userId: string; faberToken: string }) {
    return FaberApi.httpGet(`/sim/ops/voice/plan/all/${body.userId}`, {
      Authorization: `Bearer ${body.faberToken}`
    })
  }

  static terminateCustomerVoicePlan(body: {
    planId: string
    faberToken: string
  }) {
    return FaberApi.httpDelete(`/sim/ops/voice/plan/${body.planId}`, {
      Authorization: `Bearer ${body.faberToken}`
    })
  }

  static getUserVoiceCallLogs(body: {
    userId: string
    faberToken: string
    page: number
    pageSize: number
  }) {
    const { userId, faberToken, page, pageSize } = body
    return FaberApi.httpGet(
      `/sim/ops/voice/logs/${userId}?page=${page}&page_size=${pageSize}`,
      {
        Authorization: `Bearer ${faberToken}`
      }
    )
  }
}

export default EsimAPI
